import { useBoolean } from "./useBoolean";

export const useCopy = (delay?: number) => {
    const [isCopied, setIsCopied] = useBoolean();

    const copy = async (value: string, cb?: () => void) => {
        await navigator.clipboard.writeText(value);
        setIsCopied.on();
        cb?.();

        if (delay) {
            setTimeout(() => {
                setIsCopied.off();
            }, delay);
        }
    };

    return { copy, isCopied };
};
